import { render } from "./ComparativeTVPVariance.vue?vue&type=template&id=ed532104"
import script from "./ComparativeTVPVariance.vue?vue&type=script&lang=js"
export * from "./ComparativeTVPVariance.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__